import { isEmpty } from 'lodash';

const {
  i18n: { __ },
  blockEditor: { MediaUpload, MediaUploadCheck },
  components: { Button },
} = wp;

const MediaFile = ({ media, setAttributes }) => {
  return (
    <>
      <MediaUploadCheck>
        <MediaUpload
          onSelect={(file) => {
            setAttributes({
              media: {
                id: file.id,
                title: file.title,
                filename: file.filename,
                url: file.url,
                fileType: file.type,
              },
            });
          }}
          allowedTypes={['image']}
          multiple={false}
          render={({ open }) => (
            <>
              {media && (
                <div className="e-cmp__media-preview">
                  <embed key={media.id} src={media.url} alt={media.filename} />
                </div>
              )}
              <div className="e-cmp__media-buttons">
                <Button onClick={open} variant="primary">
                  {isEmpty(media.url)
                    ? __('Select an Image', 'b3rg')
                    : __('Replace', 'b3rg')}
                </Button>
                {!isEmpty(media.url) && (
                  <Button
                    variant="secondary"
                    onClick={() =>
                      setAttributes({
                        media: {},
                      })
                    }
                  >
                    {__('Remove', 'b3rg')}
                  </Button>
                )}
              </div>
            </>
          )}
        />
      </MediaUploadCheck>
    </>
  );
};

export default MediaFile;
